import { Directive } from "@angular/core";

@Directive({
  selector: "bit-label",
})
export class BitLabel {}
